import { useCallback, useState } from "react";
import { callAPI } from "../../../../utils/api";
import { useDiscordUser } from "../../../../utils/hooks/useDiscordUser";
import { useErrorToast } from "../../../../utils/showToast";

export default function useUnlink() {
  const { mutate } = useDiscordUser();

  // Unlink functionality
  const [isLoading, setIsLoading] = useState(false);
  const showErrorToast = useErrorToast();

  const unlink = useCallback(
    (onModalClose: () => void) => {
      setIsLoading(true);

      callAPI(["discord"], { method: "DELETE" })
        .catch((e) => showErrorToast(e))
        .then((res) => {
          console.debug("DELETE discord response ", res);
          mutate(null);
        })
        .finally(() => {
          setIsLoading(false);
          onModalClose();
        });
    },
    [mutate, showErrorToast]
  );

  return {
    unlink,
    isLoading,
  };
}
